import React from 'react'
import RozcestnikImage from '../../../assets/images/front/rozcestnik-pk-bg.png'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'

const PkAll: React.FC = () => {
  const history = useHistory()

  return (
    <>
      <div className="relative container mx-auto px-4 mt-[52px] md:mt-0 flex flex-col-reverse md:flex-col bg-[#F5FAFF] md:bg-transparent -mb-12">
        <img src={RozcestnikImage} alt="" className="w-full h-full object-cover hidden md:block" />
        <div className="grid px-4 lg:px-0 grid-cols-12 gap-4 my-8 md:my-0 top-0 left-0 text-white text-center md:absolute md:top-[182px] md:left-[50%] md:translate-x-[-50%] w-full max-w-[720px] mx-auto">
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#0183BA] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">5. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg">
              <span
                className="cursor-pointer w-full text-center block rounded-lg  py-1 bg-white text-xl text-black font-myriad font-semibold hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                onClick={() => history.push(routesURLs.pk5Online)}
              >
                Online
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#00A0E3] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">7. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg">
              <span
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black py-1 font-myriad font-semibold hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                onClick={() => history.push(routesURLs.pk7Online)}
              >
                Online
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#A8CD00] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">9. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg mb-2">
              <span
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                onClick={() => history.push(routesURLs.pk9Online)}
              >
                Online
              </span>
            </div>

            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] rounded-lg">
              <span
                onClick={() => history.push(routesURLs.pk9)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Prezenčně
              </span>
            </div>
          </div>
        </div>
      </div>
      <img src={RozcestnikImage} alt="" className="w-full h-full object-cover md:hidden -mt-14" />
    </>
  )
}

export default PkAll
